<style lang="scss" scoped>
.show-more-wrapper {
    .link-arrow {
        cursor: pointer;
    }
}

.v-collapse-content-end {
    & + .link-arrow {
        display: none;
    }
}
</style>

<template>
    <div class="show-more-wrapper">
        <div class="visible mb-child-0" v-if="visibleText" v-html="visibleText"></div>

        <template v-if="hiddenText != null">
            <v-collapse-wrapper class="mt-16">
                <div class="hidden-text mb-child-0" ref="hiddentext" v-collapse-content v-html="hiddenText"></div>
                <span class="link-arrow" v-show="hiddenText != null" v-collapse-toggle>Lees meer <span class="arrow-right" v-html="svg('arrow-right')" /></span>
            </v-collapse-wrapper>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        content: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            visibleText: null,
            hiddenText: null,
        }
    },

    mounted() {
        const term = '<!--more-->';
        const i = this.content.indexOf(term);

        if (i >= 0) {
            const splitArray = [this.content.slice(0, i), this.content.slice(i + term.length)];
            this.visibleText = splitArray[0];
            if (splitArray.length > 1) this.hiddenText = splitArray[1];
        } else {
            this.visibleText = this.content;
        }
    }
}
</script>